<template>
  <div class="cp-close">
    <!-- <div class="stick"></div> -->
    <div class="site" @click="handleClose($event)" />
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .cp-close
    height 0.7rem
    width 0.7rem
    position absolute
    bottom 0
    left 2.98rem
    .site
      width 0.7rem
      height 0.7rem
      background url('./images/X.png')
      background-size contain
      transition: transform .6s ease-in-out,-webkit-transform .6s ease-in-out
      cursor pointer
      &:hover
        transform rotate(360deg)
</style>
<script>
import * as types from '~/store/mutation-type';
import store from '~/store/index';
export default {
  props: {
    isMobile: {
      type: Boolean,
      default: true
    }
  },
  mounted() {

  },
  methods: {
    handleClose(e) {
      e.preventDefault();
      e.stopPropagation();
      this.$emit('close')
      // store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

